'use strict';

/**
 * BudgetGeneralController - contrôleur de la page du budget général
 * Version corrigée pour travailler avec le BudgetApiService dynamique
 */
angular
  .module('observatoireApp')
  .controller('BudgetGeneralController', BudgetGeneralController);

BudgetGeneralController.$inject = ['$scope', '$http', '$timeout', '$filter', '$location', '$state', 'Auth', 'FavorisService', 'BudgetDataService', 'BudgetApiService', 'ForumApiService'];

function BudgetGeneralController($scope, $http, $timeout, $filter, $location, $state, Auth, FavorisService, BudgetDataService, BudgetApiService, ForumApiService) {
  // Exposer Math pour pouvoir l'utiliser dans la vue
  $scope.Math = window.Math;
  
  // Années disponibles
  $scope.annees = [2025, 2024, 2023, 2022];
  
  // Configuration de l'URL de base pour le partage
  $scope.baseUrl = window.location.origin + window.location.pathname;
  
  // Récupération des paramètres de l'URL
  var searchParams = $location.search();
  console.log('Paramètres URL:', searchParams);
  
  // Initialisation des états de chargement
  $scope.loading = {
    budgetEtat: true,
    tofe: true,
    jeuxDonnees: true,
    typesDonnees: true
  };
  
  // Initialisation des filtres avec des valeurs temporaires
  $scope.filtres = {
    // Utiliser l'année de l'URL si elle existe, sinon utiliser l'année la plus récente
    annee: searchParams.annee ? parseInt(searchParams.annee) : $scope.annees[0],
    
    // Ces valeurs seront réécrites après le chargement des données
    jeuDonnees: searchParams.jeuDonnees || '',
    typeDonnees: searchParams.typeDonnees || ''
  };
  
  // Initialisation de l'onglet actif (utiliser l'onglet de l'URL si disponible)
  $scope.ongletActif = searchParams.onglet || 'graphiques';
  
  // Initialisation du filtre et du tri pour le tableau
  $scope.tableauFiltre = '';
  $scope.tableauTri = {
    champ: 'libelle',
    ordre: 'asc'
  };
  
  // Initialisation des variables de pagination pour le tableau
  $scope.tableauPagination = {
    pageCourante: 1,
    nombrePages: 1,
    elementsParPage: 10
  };
  
  // Types de graphiques disponibles
  $scope.graphiqueTypes = [
    { id: 'bar', nom: 'Barres', icon: 'fa-bar-chart' },
    { id: 'line', nom: 'Lignes', icon: 'fa-line-chart' },
    { id: 'pie', nom: 'Camembert', icon: 'fa-pie-chart' },
    { id: 'doughnut', nom: 'Anneau', icon: 'fa-circle-o-notch' }
  ];
  
  // Type de graphique par défaut
  $scope.graphiqueTypeActif = 'bar';
  
  // Jeux de données disponibles
  $scope.jeuxDonnees = [];
  $scope.typesDonnees = [];
  $scope.titreJeuDonnees = '';
  
  // Initialisation du modèle de recherche
  $scope.recherche = {
    texte: ''
  };
  
  // Vérification de l'authentification et initialisation des favoris
  $scope.utilisateurConnecte = Auth.isAuthenticated();
  $scope.estFavori = false;
  $scope.nomUtilisateur = 'Utilisateur';

  // Récupérer le nom complet de l'utilisateur connecté
  if ($scope.utilisateurConnecte) {
    Auth.identity().then(function(user) {
      if (user) {
        var prenom = user.firstName || '';
        var nom = user.lastName || '';
        $scope.nomUtilisateur = (prenom + ' ' + nom).trim() || user.username || 'Utilisateur';
      }
    });
  }
  
  // Fonction pour basculer l'état du favori
  $scope.toggleFavori = function() {
    if (!$scope.utilisateurConnecte) {
      $scope.ouvrirModalConnexion();
      return;
    }
    
    // Récupérer les libellés pour le jeu de données et le type
    var jeuDonnees = $scope.jeuxDonnees.find(function(j) { 
      return j.id === $scope.filtres.jeuDonnees; 
    });
    
    var typeDonnees = jeuDonnees && jeuDonnees.types.find(function(t) { 
      return t.id === $scope.filtres.typeDonnees; 
    });
    
    if (!jeuDonnees || !typeDonnees) {
      console.error('Impossible de trouver le jeu de données ou le type sélectionné');
      return;
    }
    
    // Construire l'identifiant unique du dataset
    var datasetId = $scope.filtres.jeuDonnees + '-' + $scope.filtres.typeDonnees + '-' + $scope.filtres.annee;
    
    var dataset = {
      id: datasetId,
      jeuDonnees: $scope.filtres.jeuDonnees,
      jeuDonneesLibelle: jeuDonnees.libelle,
      typeDonnees: $scope.filtres.typeDonnees,
      typeDonneesLibelle: typeDonnees.libelle,
      annee: $scope.filtres.annee
    };
    
    if ($scope.estFavori) {
      FavorisService.removeFavori(dataset.id);
      $scope.estFavori = false;
    } else {
      FavorisService.addFavori(dataset);
      $scope.estFavori = true;
    }
  };
  
  // Fonction pour rediriger vers la page de connexion
  $scope.ouvrirModalConnexion = function() {
    $state.go('login');
  };
  
  // Observer les changements dans les filtres pour mettre à jour l'état du favori
  $scope.$watch('filtres', function(newVal, oldVal) {
    if (newVal !== oldVal && $scope.utilisateurConnecte) {
      var datasetId = $scope.filtres.jeuDonnees + '-' + $scope.filtres.typeDonnees + '-' + $scope.filtres.annee;
      $scope.estFavori = FavorisService.isFavori(datasetId);
    }
  }, true);
  
  // Initialisation du modèle d'indexation et de gestion des étiquettes (tags)
  $scope.indexation = {
    categorie: '',
    nouveauxTags: '',
    recherche: ''
  };
  
  // Initialisation des filtres de tags
  $scope.filtres.tags = [];
  
  // Tags populaires prédéfinis
  $scope.tagsPopulaires = [
    { nom: 'Éducation', count: 12 },
    { nom: 'Santé', count: 9 },
    { nom: 'Infrastructure', count: 8 },
    { nom: 'Agriculture', count: 7 },
    { nom: 'Défense', count: 5 }
  ];
  
  // Sources de données (remplacées par l'API dynamique)
  $scope.donnees = null;
  $scope.donneesIndexees = [];
  
  // Initialiser les données filtrées avec toutes les données au départ
  $scope.donneesIndexeesFiltrees = [];
  
  // Onglet actif par défaut
  $scope.ongletActif = 'graphiques';
  
  // Palette partagée pour les couleurs de graphique
  var chartPalette = [
    '#3366CC', '#DC3912', '#FF9900', '#109618', '#990099',
    '#0099C6', '#DD4477', '#66AA00', '#B82E2E', '#316395',
    '#994499', '#22AA99', '#AAAA11', '#6633CC', '#E67300',
    '#8B0707', '#329262', '#5574A6'
  ];

  // Retourne la couleur correspondant à un index donné
  $scope.getChartColor = function(index) {
    return chartPalette[index % chartPalette.length];
  };

  // Fonction pour changer le type de graphique
  $scope.changerTypeGraphique = function(typeId) {
    console.log('Changement du type de graphique:', typeId);
    $scope.graphiqueTypeActif = typeId;
    mettreAJourGraphiques();
  };
  
  // Fonction pour changer d'onglet
  $scope.changerOnglet = function(onglet) {
    console.log('Changement d\'onglet vers:', onglet);
    $scope.ongletActif = onglet;
    
    // Si on va à l'onglet graphique, mettre à jour les graphiques
    if (onglet === 'graphiques') {
      mettreAJourGraphiques();
    }
    // Si on va à l'onglet forum, charger les discussions
    else if (onglet === 'forum') {
      chargerDiscussions();
    }
    // Si on va à l'onglet documents, charger les documents
    else if (onglet === 'documents') {
      chargerDocuments();
    }
  };

  // Fonction pour changer le jeu de données
  $scope.changerJeuDonnees = function(jeuId) {
    console.log('Changement du jeu de données:', jeuId);
    // Réinitialiser le type de données et le jeu actif
    $scope.filtres.typeDonnees = null;
    $scope.typesDonnees = [];
    
    // Trouver le jeu de données sélectionné
    var jeuSelectionne = $scope.jeuxDonnees.find(function(j) { return j.id === jeuId; });
    if (jeuSelectionne) {
      $scope.titreJeuDonnees = jeuSelectionne.libelle;
      
      // Charger les types de données associés
      $scope.loading.typesDonnees = true;
      BudgetApiService.getTypesDonnees(jeuId)
        .then(function(response) {
          console.log('Types de données récupérés depuis l\'API:', response.data);
          $scope.typesDonnees = response.data.map(function(type) {
            return { id: type.code, libelle: type.libelle };
          });
          
          // Sélectionner le premier type de données par défaut
          if ($scope.typesDonnees.length > 0) {
            $scope.filtres.typeDonnees = $scope.typesDonnees[0].id;
            // Charger les données avec le premier type
            chargerDonnees();
          }
          $scope.loading.typesDonnees = false;
        })
        .catch(function(error) {
          console.error('Erreur lors de la récupération des types de données:', error);
          $scope.loading.typesDonnees = false;
        });
    }
  };

  // Fonction pour changer le type de données
  $scope.changerTypeDonnees = function(typeId) {
    console.log('Changement du type de données:', typeId);
    // Mettre à jour l'URL et recharger les données
    $location.search('typeDonnees', typeId);
    chargerDonnees();
  };

  // Fonction pour changer l'année
  $scope.changerAnnee = function(annee) {
    console.log('Changement d\'année:', annee);
    // Mettre à jour l'URL et recharger les données
    $location.search('annee', annee);
    chargerDonnees();
  };
  
  // Fonction pour filtrer les données par texte
  $scope.filtrerParTexte = function() {
    console.log('Filtrage des données par texte:', $scope.recherche.texte);
    $scope.filtrerDonnees();
  };

  // Variable pour suivre si un graphique est en cours de création
  var creationGraphiqueEnCours = false;

  // Fonction pour mettre à jour les graphiques
  function mettreAJourGraphiques() {
    // Vérifier si un graphique est déjà en cours de création
    if (creationGraphiqueEnCours) {
      console.log('Création de graphique déjà en cours, mise en attente');
      return;
    }

    creationGraphiqueEnCours = true;
    console.log('Mise à jour des graphiques avec les données filtrées:', $scope.donneesIndexeesFiltrees);

    // S'assurer qu'il y a des données à afficher
    if (!$scope.donneesIndexeesFiltrees || $scope.donneesIndexeesFiltrees.length === 0) {
      console.warn('Pas de données disponibles pour les graphiques');
      creationGraphiqueEnCours = false;
      return;
    }
    
    // Vérifier que l'onglet graphiques est bien sélectionné
    if ($scope.ongletActif !== 'graphiques') {
      console.log('Onglet graphiques non actif, mise en pause de la mise à jour des graphiques');
      creationGraphiqueEnCours = false;
      return;
    }
    
    // Vérifier que le canvas existe dans le DOM
    var canvas = document.getElementById('tofeChart');
    if (!canvas) {
      console.error('Canvas tofeChart introuvable dans le DOM');
      // Attendre un peu et réessayer (le DOM pourrait ne pas être encore prêt)
      $timeout(function() {
        creationGraphiqueEnCours = false;
        mettreAJourGraphiques();
      }, 500);
      return;
    }

    // S'assurer que toutes les anciennes instances de graphiques sont supprimées
    try {
      // Détruire complètement l'ancien graphique
      if (window.tofeChart) {
        var ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        window.tofeChart = null;
        $scope.tofeChart = null;
      }
      
      // Réinitialiser le canvas
      canvas.width = canvas.width; // Astuce pour réinitialiser le canvas
      
      // Supprimer et recréer le canvas pour éviter les références croisées
      var parent = canvas.parentNode;
      if (parent) {
        parent.removeChild(canvas);
        canvas = document.createElement('canvas');
        canvas.id = 'tofeChart';
        canvas.width = parent.offsetWidth;
        canvas.height = 400;
        parent.appendChild(canvas);
      }
    } catch(e) {
      console.error('Erreur lors de la suppression du graphique existant:', e);
    }

    try {
      // Préparer les données pour le graphique
      var labels = [];
      var montants = [];
      var couleurs = [];
      var couleursHover = [];
      
      // Palette de couleurs pour les graphiques
      var palette = chartPalette;
      
      // Filtrer les données pour exclure les totaux et récupérer les 10 premiers éléments
      var donneesFiltrees = $scope.donneesIndexeesFiltrees.filter(function(item) {
        // Exclure les totaux d'abord
        var pasUnTotal = !item.libelle || 
               (item.libelle.toLowerCase().indexOf('total') === -1 &&
                item.code !== 'TOTAL' &&
                item.code !== 'total' &&
                item.type !== 'TOTAL' &&
                item.type !== 'total');

        // Vérifier si on filtre par type
        if (pasUnTotal && $scope.typeDonneesActif && $scope.typeDonneesActif !== 'all') {
          return item.type === $scope.typeDonneesActif;
        }
        
        return pasUnTotal;
      });
      
      // Récupérer les 10 premiers éléments pour le graphique
      var donneesGraphique = donneesFiltrees.slice(0, 10);
      
      // Préparer les données pour le graphique
      donneesGraphique.forEach(function(item, index) {
        // Tronquer les libellés trop longs pour une meilleure lisibilité dans les graphiques
        var libelle = item.libelle;
        if ($scope.graphiqueTypeActif === 'bar' || $scope.graphiqueTypeActif === 'line') {
          // Limiter à 25 caractères et ajouter ... si plus long
          if (libelle && libelle.length > 25) {
            libelle = libelle.substring(0, 22) + '...';
          }
        }
        labels.push(libelle);
        montants.push(Math.round(item.montant / 1000000)); // Convertir en millions
        
        // Utiliser une couleur de la palette ou générer une couleur aléatoire
        var couleur = palette[index % palette.length];
        couleurs.push(couleur);
        
        // Couleur de surbrillance (plus claire pour l'effet hover)
        var couleurHover = couleur;
        if ($scope.graphiqueTypeActif === 'pie' || $scope.graphiqueTypeActif === 'doughnut') {
          // Pour les graphiques circulaires, rendre la couleur plus claire
          couleurHover = couleur.replace('CC', 'FF').replace('99', 'BB').replace('66', '88');
        }
        couleursHover.push(couleurHover);
      });
      
      // Vérifier à nouveau que le canvas est prêt
      canvas = document.getElementById('tofeChart');
      if (!canvas) {
        console.error('Canvas toujours introuvable après préparation des données');
        return;
      }
      
      // Préparer l'objet de données pour Chart.js
      var chartData;
      var ctx = canvas.getContext('2d');

      // Réinitialiser le canvas avec les dimensions correctes
      var canvasWidth = canvas.parentNode.offsetWidth;
      var canvasHeight = 400; // Hauteur fixe ou adaptative selon besoin
      canvas.width = canvasWidth;
      canvas.height = canvasHeight;
      
      var options = {
        responsive: true,
        maintainAspectRatio: false,
        animation: true,
        animationSteps: 60, // Ralentir l'animation pour éviter les bugs d'affichage
        showTooltips: true
      };
      
      // Définir le template de légende en fonction du type de graphique
      if ($scope.graphiqueTypeActif === 'pie' || $scope.graphiqueTypeActif === 'doughnut') {
        // Template pour graphiques circulaires
        options.legendTemplate = '<ul class="<%=name.toLowerCase()%>-legend"><% for (var i=0; i<segments.length; i++){%><li><span style="background-color:<%=segments[i].fillColor%>"></span><%if(segments[i].label){%><%=segments[i].label%>: <%=Math.round(segments[i].value).toLocaleString()%> millions FCFA (<%=Math.round(segments[i].percentage)%>%)<%}%></li><%}%></ul>';
      } else {
        // Template pour graphiques en barres/lignes
        options.legendTemplate = '<ul class="<%=name.toLowerCase()%>-legend"><% for (var i=0; i<datasets.length; i++){%><li><span style="background-color:<%=datasets[i].fillColor%>"></span><%if(datasets[i].label){%><%=datasets[i].label%><%}%></li><%}%></ul>';
      }
      
      if ($scope.graphiqueTypeActif === 'bar') {
        // Pour le graphique en barres, utiliser un seul dataset coloré selon le type
        var barColor;
        
        // Utiliser la même palette de couleurs que pour les graphiques pie/doughnut
        var paletteIndex = 0;
        
        // Déterminer l'index de couleur en fonction du type sélectionné
        if ($scope.typeDonneesActif) {
          // Rechercher l'index de type dans une liste prédéfinie de types
          var typesConnus = [
            'Recettes fiscales',
            'Dons, legs et fonds de concours',
            'Revenus du domaine et des activités',
            'Produits financiers',
            'Autres recettes'
          ];
          
          paletteIndex = typesConnus.indexOf($scope.typeDonneesActif);
          if (paletteIndex === -1) paletteIndex = 0;  // Défaut si type non trouvé
        }
        
        // Utiliser la couleur de la palette correspondant à l'index
        barColor = palette[paletteIndex % palette.length];
        
        // Créer un dataset unique avec toutes les barres de la même couleur
        chartData = {
          labels: labels,
          datasets: [{
            label: $scope.typeDonneesActif || 'Montant (millions FCFA)',
            fillColor: barColor,
            strokeColor: barColor,
            highlightFill: couleursHover[paletteIndex % couleursHover.length],
            highlightStroke: barColor,
            data: montants
          }]
        };
      } else if ($scope.graphiqueTypeActif === 'line') {
        // Pour le graphique en ligne, utiliser le même code couleur que pour les barres
        var lineColor;
        
        // Utiliser la même palette de couleurs que pour les graphiques bar
        var paletteIndex = 0;
        
        // Déterminer l'index de couleur en fonction du type sélectionné
        if ($scope.typeDonneesActif) {
          // Rechercher l'index de type dans une liste prédéfinie de types
          var typesConnus = [
            'Recettes fiscales',
            'Dons, legs et fonds de concours',
            'Revenus du domaine et des activités',
            'Produits financiers',
            'Autres recettes'
          ];
          
          paletteIndex = typesConnus.indexOf($scope.typeDonneesActif);
          if (paletteIndex === -1) paletteIndex = 0;  // Défaut si type non trouvé
        }
        
        // Utiliser la couleur de la palette correspondant à l'index
        lineColor = palette[paletteIndex % palette.length];
        
        chartData = {
          labels: labels,
          datasets: [
            {
              label: $scope.typeDonneesActif || 'Montant (millions FCFA)',
              fillColor: 'rgba(220, 220, 220, 0.1)',
              strokeColor: lineColor,
              pointColor: lineColor,
              pointStrokeColor: '#fff',
              pointHighlightFill: '#fff',
              pointHighlightStroke: lineColor,
              data: montants
            }
          ]
        };
        options.multiTooltipTemplate = '<%= datasetLabel %>: <%= value.toLocaleString() %> millions FCFA';
        
        // Options spécifiques pour Chart.js 1.1.1 (structure différente des versions plus récentes)
        options.scaleLabel = '<%= value.toLocaleString() %> M';
        options.scaleFontSize = 12;
        options.scaleBeginAtZero = true;
        options.scaleShowGridLines = true;
        // Rotation des labels pour éviter les chevauchements
        options.scaleShowLabels = true;
        options.scaleFontFamily = '"Helvetica Neue", Helvetica, Arial, sans-serif';
        options.scaleLineColor = 'rgba(0,0,0,.1)';
        options.scaleGridLineColor = 'rgba(0,0,0,.05)';
        
        // Augmenter l'espacement pour mieux voir les labels
        options.barValueSpacing = 5;
        options.barDatasetSpacing = 1;
        
        // Personnalisation des infobulles
        options.tooltipTemplate = '<%= label %>: <%= value.toLocaleString() %> millions FCFA';
        options.tooltipFillColor = 'rgba(0,0,0,0.8)';
        options.tooltipFontSize = 12;
        options.tooltipCornerRadius = 3;
        options.tooltipYPadding = 6;
        options.tooltipXPadding = 10;
      } else {
        // Format pour les graphiques circulaires (pie et doughnut)
        chartData = [];
        for (var i = 0; i < labels.length; i++) {
          chartData.push({
            value: montants[i],
            label: labels[i],
            color: couleurs[i],
            highlight: couleursHover[i]
          });
        }
      }
      
      // Créer le graphique en fonction du type sélectionné
      $timeout(function() {
        try {
          // S'assurer qu'on a un canvas propre
          var chartCanvas = document.getElementById('tofeChart');
          if (!chartCanvas) {
            console.error('Canvas not found during chart creation');
            creationGraphiqueEnCours = false;
            return;
          }

          // Récupérer le contexte une dernière fois pour s'assurer qu'il est valide
          ctx = chartCanvas.getContext('2d');
          
          // Désactiver les événements de souris temporairement pour éviter les problèmes de survol multiples
          chartCanvas.style.pointerEvents = 'none';
          
          var newChart = null;
          if ($scope.graphiqueTypeActif === 'line') {
            options.multiTooltipTemplate = '<%= datasetLabel %>: <%= value.toLocaleString() %> millions FCFA';
            newChart = new Chart(ctx).Line(chartData, options);
          } else if ($scope.graphiqueTypeActif === 'pie') {
            newChart = new Chart(ctx).Pie(chartData, options);
          } else if ($scope.graphiqueTypeActif === 'doughnut') {
            newChart = new Chart(ctx).Doughnut(chartData, options);
          } else {
            // Par défaut, utiliser un graphique en barres
            newChart = new Chart(ctx).Bar(chartData, options);
          }
          
          // Réactiver les événements après création complète
          $timeout(function() {
            chartCanvas.style.pointerEvents = 'auto';
          }, 100);
          
          // Stocker la référence au graphique uniquement quand tout est terminé
          window.tofeChart = newChart;
          $scope.tofeChart = newChart;
          console.log('Graphique créé avec succès:', $scope.graphiqueTypeActif);
          
          // Réinitialiser le flag de création de graphique
          creationGraphiqueEnCours = false;
        } catch (err) {
          console.error('Erreur lors de la création du graphique:', err);
          creationGraphiqueEnCours = false;
        }
      }, 200); // Délai plus long pour s'assurer que le DOM est prêt
    } catch (error) {
      console.error('Erreur lors de la préparation des données du graphique:', error);
      creationGraphiqueEnCours = false;
    }
  }
  
  // Fonction pour initialiser la page
  function initialiser() {
    // Récupérer d'abord les jeux de données disponibles
    console.log('Récupération des jeux de données depuis l\'API...');
    
    BudgetApiService.getJeuxDonnees()
      .then(function(response) {
        // Mise à jour des jeux de données disponibles
        console.log('Jeux de données récupérés depuis l\'API:', response.data);
        $scope.jeuxDonnees = response.data.map(function(jeu) {
          return { 
            id: jeu.code, 
            libelle: jeu.libelle,
            types: [] // Sera rempli lors du chargement des types
          };
        });
        
        $scope.loading.jeuxDonnees = false;
        
        // Déterminer le jeu de données par défaut si aucun n'est spécifié dans l'URL
        if (!searchParams.jeuDonnees && $scope.jeuxDonnees.length > 0) {
          // Chercher d'abord le TOFE, puis le Budget de l'État, ou prendre le premier
          var tofeJeu = $scope.jeuxDonnees.find(function(jeu) {
            return jeu.libelle.toLowerCase().includes('tableau des opérations') ||
                   jeu.libelle.toLowerCase().includes('operations financieres');
          });
          
          var budgetJeu = $scope.jeuxDonnees.find(function(jeu) {
            return jeu.libelle.toLowerCase().includes('budget de l\'état') ||
                   jeu.libelle.toLowerCase().includes('budget de l\'etat');
          });
          
          // Priorité 1: TOFE, Priorité 2: Budget, Priorité 3: Premier jeu disponible
          $scope.filtres.jeuDonnees = tofeJeu ? tofeJeu.id : (budgetJeu ? budgetJeu.id : $scope.jeuxDonnees[0].id);
        } else if (searchParams.jeuDonnees) {
          // Vérifier que le jeu de données spécifié dans l'URL existe bien
          var jeuExiste = $scope.jeuxDonnees.some(function(jeu) {
            return jeu.id === searchParams.jeuDonnees;
          });
          
          if (!jeuExiste && $scope.jeuxDonnees.length > 0) {
            console.log('Jeu de données non trouvé dans l\'API, sélection du premier disponible');
            $scope.filtres.jeuDonnees = $scope.jeuxDonnees[0].id;
          } else {
            $scope.filtres.jeuDonnees = searchParams.jeuDonnees;
          }
        }
        
        // Récupérer le jeu de données sélectionné
        var jeuDonneesSelectionne = $scope.jeuxDonnees.find(function(jeu) { 
          return jeu.id === $scope.filtres.jeuDonnees; 
        });
        
        if (jeuDonneesSelectionne) {
          $scope.titreJeuDonnees = jeuDonneesSelectionne.libelle;
          // Récupérer les types de données pour ce jeu
          console.log('Récupération des types de données pour', $scope.filtres.jeuDonnees);
          
          BudgetApiService.getTypesDonnees($scope.filtres.jeuDonnees)
            .then(function(response) {
              console.log('Types de données récupérés:', response.data);
              
              // Mettre à jour les types disponibles pour le jeu sélectionné
              var types = response.data.map(function(type) {
                return { id: type.code, libelle: type.libelle };
              });
              
              // Mettre à jour les types dans le jeu de données sélectionné
              jeuDonneesSelectionne.types = types;
              $scope.typesDonnees = types;
              $scope.loading.typesDonnees = false;
              
              // Déterminer le type de données par défaut si aucun n'est spécifié dans l'URL
              if (!searchParams.typeDonnees && types.length > 0) {
                $scope.filtres.typeDonnees = types[0].id;
              } else if (searchParams.typeDonnees) {
                // Vérifier que le type spécifié existe bien
                var typeExiste = types.some(function(type) {
                  return type.id === searchParams.typeDonnees;
                });
                
                if (!typeExiste && types.length > 0) {
                  console.log('Type de données non trouvé dans l\'API, sélection du premier disponible');
                  $scope.filtres.typeDonnees = types[0].id;
                } else {
                  $scope.filtres.typeDonnees = searchParams.typeDonnees;
                }
              }
              
              // Initialisation de l'état de favori si l'utilisateur est connecté
              if ($scope.utilisateurConnecte) {
                var datasetId = $scope.filtres.jeuDonnees + '-' + $scope.filtres.typeDonnees + '-' + $scope.filtres.annee;
                $scope.estFavori = FavorisService.isFavori(datasetId);
              }
              
              // Charger les données avec les filtres finaux
              console.log('Filtres finaux:', $scope.filtres);
              chargerDonnees();
            })
            .catch(function(error) {
              console.error('Erreur lors de la récupération des types de données:', error);
              $scope.loading.typesDonnees = false;
            });
        } else {
          console.error('Aucun jeu de données n\'a été sélectionné, impossible de charger les données');
        }
      })
      .catch(function(error) {
        console.error('Erreur lors de la récupération des jeux de données:', error);
        $scope.loading.jeuxDonnees = false;
      });
  }
  
  // Fonction pour charger les données depuis l'API
  function chargerDonnees() {
    console.log('Chargement des données avec les filtres:', $scope.filtres);
    $scope.loading.budgetEtat = true;
    $scope.loading.tofe = true;
    
    // Mise à jour de l'URL avec les paramètres des filtres
    $location.search('jeuDonnees', $scope.filtres.jeuDonnees);
    $location.search('typeDonnees', $scope.filtres.typeDonnees);
    $location.search('annee', $scope.filtres.annee);
    
    // Utiliser l'API générique pour tous les jeux de données
    var dataPromise;
    
    if ($scope.filtres.jeuDonnees) {
      // Utiliser la méthode générique pour tous les jeux de données
      dataPromise = BudgetApiService.getDonneesFormattees(
        $scope.filtres.jeuDonnees,
        $scope.filtres.typeDonnees, 
        $scope.filtres.annee
      );
    } else {
      console.error('Aucun jeu de données sélectionné, impossible de charger les données');
      $scope.loading.budgetEtat = false;
      $scope.loading.tofe = false;
      return;
    }
    
    // Traiter les données lorsqu'elles sont reçues
    dataPromise.then(function(response) {
      // Charger également les discussions si l'onglet forum est actif
      if ($scope.ongletActif === 'forum') {
        chargerDiscussions();
      } else if ($scope.ongletActif === 'fichiers') {
        chargerDocuments();
      }
      console.log('Données récupérées:', response.data);
      
      $scope.donnees = response.data;
      $scope.donneesBrutes = angular.copy(response.data);
      $scope.donneesIndexees = flattenData(response.data);
      $scope.donneesIndexeesFiltrees = $scope.donneesIndexees.slice();
      
      // Initialisation du tableau de données pour l'affichage
      $scope.tableauDonneesFiltrees = $scope.donneesIndexees.slice();
      
      // Mise à jour des graphiques
      mettreAJourGraphiques();
      
      $scope.loading.budgetEtat = false;
      $scope.loading.tofe = false;
    }).catch(function(error) {
      console.error('Erreur lors de la récupération des données:', error);
      $scope.loading.budgetEtat = false;
      $scope.loading.tofe = false;
      mockDonnees();
    });
  }
  
  // Fonction pour créer des données mockées en cas d'erreur de chargement
  function mockDonnees() {
    $scope.donnees = {
      libelle: 'Total',
      montant: 1000000000,
      pourcentage: 100,
      enfants: [
        { libelle: 'Recettes fiscales', montant: 400000000, pourcentage: 40 },
        { libelle: 'Recettes non fiscales', montant: 300000000, pourcentage: 30 },
        { libelle: 'Dons et subventions', montant: 200000000, pourcentage: 20 },
        { libelle: 'Autres recettes', montant: 100000000, pourcentage: 10 }
      ]
    };
    $scope.donneesBrutes = angular.copy($scope.donnees);
    $scope.donneesIndexees = flattenData($scope.donnees);
    $scope.donneesIndexeesFiltrees = $scope.donneesIndexees.slice();
    $scope.tableauDonneesFiltrees = $scope.donneesIndexees.slice();
    mettreAJourGraphiques();
  }
  
  // Fonction pour transformer des données hiérarchiques en liste plate pour l'indexation
  function flattenData(data, parent = null, level = 0, path = []) {
    var result = [];
    
    if (!data) return result;
    
    if (data.libelle) {
      // Ajouter l'élément courant
      var currentPath = path.slice();
      currentPath.push(data.libelle);
      
      var item = {
        libelle: data.libelle,
        montant: data.montant,
        pourcentage: data.pourcentage,
        level: level,
        parent: parent,
        path: currentPath.join(' > ')
      };
      
      result.push(item);
      
      // Traiter les enfants s'ils existent
      if (data.enfants && data.enfants.length > 0) {
        data.enfants.forEach(function(child) {
          var childrenResults = flattenData(child, data.libelle, level + 1, currentPath);
          result = result.concat(childrenResults);
        });
      }
    }
    
    return result;
  }
  
  // Fonction pour filtrer les données en fonction de la recherche
  $scope.filtrerDonnees = function() {
    if (!$scope.recherche.texte) {
      // Si aucun texte de recherche, afficher toutes les données
      $scope.donneesIndexeesFiltrees = $scope.donneesIndexees.slice();
    } else {
      // Filtrer les données en fonction du texte de recherche
      var texteRecherche = $scope.recherche.texte.toLowerCase();
      $scope.donneesIndexeesFiltrees = $scope.donneesIndexees.filter(function(item) {
        return item.libelle.toLowerCase().includes(texteRecherche) || 
               (item.path && item.path.toLowerCase().includes(texteRecherche));
      });
    }
    
    // Mettre à jour les graphiques avec les données filtrées
    mettreAJourGraphiques();
  };
  
  // Documents budgétaires
  $scope.documents = [];
  $scope.documentsLoading = false;
  
  // Forum budgétaire
  $scope.discussions = [];
  $scope.discussionsFiltrees = [];
  $scope.chargementForum = false;
  $scope.chargementReponses = false;
  $scope.repondreEnCours = false;
  $scope.publierEnCours = false;
  $scope.triDiscussions = 'date_desc';
  $scope.forumPagination = {
    pageCourante: 1,
    nombrePages: 1,
    elementsParPage: 5
  };
  
  // Initialisation des variables du forum
  $scope.chargementForum = false;
  $scope.publierEnCours = false;
  $scope.repondreEnCours = false;
  $scope.discussions = [];
  $scope.discussionsFiltrees = [];
  
  // Filtres pour le forum
  $scope.forumFiltre = {
    texte: '',
    tri: 'date_desc'
  };
  
  // Pagination du forum
  $scope.forumPagination = {
    pageCourante: 1,
    nombrePages: 1,
    elementsParPage: 5
  };
  
  // Initialisation du nouveau message
  $scope.nouveauMessage = {
    titre: '',
    contenu: ''
  };
  
  // Fonction pour changer d'onglet
  $scope.changerOnglet = function(onglet) {
    console.log('Changement d\'onglet: ' + onglet);
    $scope.ongletActif = onglet;
    
    // Charger les contenus spécifiques selon l'onglet activé
    if (onglet === 'fichiers') {
      chargerDocuments();
    } else if (onglet === 'forum') {
      chargerDiscussions();
    }
    
    // Mettre à jour l'URL avec le nouvel onglet
    $location.search('onglet', onglet);
  };
  
  // Fonction pour charger les documents
  function chargerDocuments() {
    if (!$scope.filtres.jeuDonnees) {
      console.warn('Aucun jeu de données sélectionné. Documents non chargés.');
      return;
    }
    
    $scope.documentsLoading = true;
    console.log('Chargement des documents pour:', 
      $scope.filtres.jeuDonnees, $scope.filtres.typeDonnees, $scope.filtres.annee);
    
    BudgetApiService.getDocuments(
      $scope.filtres.jeuDonnees,
      $scope.filtres.typeDonnees,
      $scope.filtres.annee
    ).then(function(response) {
      console.log('Réponse API reçue: ' + (response && response.data ? response.data.length : 0) + ' documents');
      
      if (response && response.data && response.data.length > 0) {
        // Inspection de la réponse pour comprendre sa structure
        console.log('[DEBUG] Structure d\'un document:', response.data[0]);
        var sampleDoc = response.data[0];
        
        // Traitement des documents pour s'assurer qu'ils ont tous les champs nécessaires
        // En utilisant directement les propriétés du modèle BudgetDocument du backend
        $scope.documents = response.data.map(function(doc) {
          return {
            id: doc.id,
            titre: doc.titre || doc.nom || 'Document sans nom',
            description: doc.description || 'Document budgétaire ' + doc.typeFichier,
            url: doc.urlFichier || '/api/budget-documents/' + doc.id + '/download',
            typeFichier: doc.typeFichier || 'Document',
            annee: doc.annee,
            jeuDonnees: doc.jeuDonnees ? (doc.jeuDonnees.code || doc.jeuDonnees) : $scope.filtres.jeuDonnees,
            typeDonnees: doc.typeDonnees ? (doc.typeDonnees.code || doc.typeDonnees) : $scope.filtres.typeDonnees
          };
        });
        console.log('Documents chargés et formatés:', $scope.documents);
        
        console.log('Documents formatés: ' + $scope.documents.length + ' documents');
      } else {
        $scope.documents = [];
        console.log('Aucun document reçu de l\'API');
      }
      $scope.documentsLoading = false;
    }).catch(function(error) {
      console.error('Erreur lors du chargement des documents:', error);
      $scope.documents = [];
      $scope.documentsLoading = false;
      
      // Pour aider au debug, afficher les détails de l'erreur dans la console
      if (error.status) {
        console.error('Status HTTP:', error.status);
        console.error('Message:', error.statusText);
        if (error.data) {
          console.error('Détails:', error.data);
        }
      }
      
      // Ajout de documents fictifs pour tester l'interface si l'API échoue
      if ($scope.filtres.jeuDonnees === 'budget-etat' || $scope.filtres.jeuDonnees === 'BUDGET_GENERAL') {
        $scope.documents = [
          {
            id: 1,
            titre: 'Loi de finances ' + $scope.filtres.annee,
            description: 'Document budgétaire officiel pour l\'année ' + $scope.filtres.annee,
            url: '#',
            typeFichier: 'PDF',
            annee: $scope.filtres.annee
          },
          {
            id: 2,
            titre: 'Données brutes ' + $scope.filtres.annee,
            description: 'Données budgétaires au format Excel',
            url: '#',
            typeFichier: 'Excel',
            annee: $scope.filtres.annee
          }
        ];
        console.log('Documents fictifs ajoutés pour test:', $scope.documents);
      }
    });
  }
  
  // Fonction pour télécharger un fichier
  $scope.telechargerFichier = function(documentUrl) {
    console.log('Téléchargement du fichier:', documentUrl);
    
    if (!documentUrl) {
      console.error('Impossible de télécharger le fichier, URL non définie');
      alert('Erreur: Impossible de télécharger ce document.');
      return;
    }
    
    // Si c'est une URL simulée (pour les tests), afficher une alerte
    if (documentUrl === '#') {
      alert('Fonction de téléchargement non disponible en mode démonstration.');
      return;
    }
    
    // Ouvrir l'URL dans un nouvel onglet pour télécharger directement le fichier
    // Cette méthode est plus simple et fonctionne bien pour les téléchargements directs
    window.open(documentUrl, '_blank');
  };
  
  // Fonction pour partager un fichier sur les réseaux sociaux
  $scope.partagerFichier = function(document, reseau) {
    console.log('Partage du document sur ' + reseau + ':', document);
    
    if (!document || !document.titre) {
      console.error('Impossible de partager le document, informations manquantes');
      alert('Erreur: Impossible de partager ce document.');
      return;
    }
    
    try {
      // Créer les paramètres de partage
      var titre = encodeURIComponent('Document budgétaire: ' + document.titre);
      var texte = encodeURIComponent('Consultez ce document budgétaire: ' + document.titre);
      
      // URL à partager (soit celle du document, soit celle de la page actuelle avec un paramètre)
      var url = document.url;
      if (url === '#') {
        // Si c'est un document de test, partager l'URL de la page actuelle
        url = window.location.href;
      }
      url = encodeURIComponent(url);
      
      // Créer l'URL de partage selon le réseau
      var lienPartage;
      var shareWindow;
      
      switch (reseau) {
        case 'facebook':
          lienPartage = 'https://www.facebook.com/sharer/sharer.php?u=' + url;
          shareWindow = window.open(lienPartage, '_blank', 'width=600,height=400');
          break;
          
        case 'twitter':
          lienPartage = 'https://twitter.com/intent/tweet?text=' + texte + '&url=' + url;
          shareWindow = window.open(lienPartage, '_blank', 'width=600,height=400');
          break;
          
        case 'linkedin':
          lienPartage = 'https://www.linkedin.com/sharing/share-offsite/?url=' + url;
          shareWindow = window.open(lienPartage, '_blank', 'width=600,height=400');
          break;
          
        case 'whatsapp':
          lienPartage = 'https://api.whatsapp.com/send?text=' + texte + '%20' + url;
          shareWindow = window.open(lienPartage, '_blank', 'width=600,height=400');
          break;
          
        case 'email':
          var mailtoLink = 'mailto:?subject=' + titre + '&body=' + texte + '%0A%0A' + url;
          window.location.href = mailtoLink;
          break;
          
        case 'telegram':
          lienPartage = 'https://t.me/share/url?url=' + url + '&text=' + texte;
          shareWindow = window.open(lienPartage, '_blank', 'width=600,height=400');
          break;
          
        default:
          console.error('Réseau social non pris en charge:', reseau);
          return;
      }
      
      // Focus sur la fenêtre de partage
      if (shareWindow) {
        shareWindow.focus();
      }
      
      console.log('Partage réussi sur ' + reseau);
    } catch (error) {
      console.error('Erreur lors du partage sur ' + reseau + ':', error);
      alert('Une erreur s\'est produite lors du partage. Veuillez réessayer.');
    }
  };
  
  // Déterminer le type d'icône à afficher selon le type de fichier
  $scope.getDocumentIcon = function(document) {
    if (!document || !document.typeFichier) {
      return 'fa-file'; // Icône par défaut si pas de type défini
    }
    
    var type = document.typeFichier.toLowerCase();
    
    // D'abord essayer les correspondances exactes
    switch (type) {
      case 'pdf':
        return 'fa-file-pdf';
      case 'xlsx':
      case 'xls':
      case 'excel':
        return 'fa-file-excel';
      case 'doc':
      case 'docx':
      case 'word':
        return 'fa-file-word';
      case 'ppt':
      case 'pptx':
      case 'powerpoint':
        return 'fa-file-powerpoint';
      case 'txt':
      case 'text':
        return 'fa-file-text';
      case 'csv':
        return 'fa-file-csv';
      case 'zip':
      case 'rar':
      case '7z':
        return 'fa-file-archive';
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'gif':
        return 'fa-file-image';
    }
    
    // Ensuite, vérifier les correspondances partielles
    if (type.includes('pdf')) {
      return 'fa-file-pdf';
    } else if (type.includes('excel') || type.includes('xls')) {
      return 'fa-file-excel';
    } else if (type.includes('word') || type.includes('doc')) {
      return 'fa-file-word';
    } else if (type.includes('powerpoint') || type.includes('ppt')) {
      return 'fa-file-powerpoint';
    } else if (type.includes('image') || type.includes('jpg') || type.includes('png')) {
      return 'fa-file-image';
    } else if (type.includes('text') || type.includes('txt')) {
      return 'fa-file-text';
    } else {
      return 'fa-file'; // Icône générique de fichier
    }
  };
  
  // Fonctions pour la gestion du forum
  function chargerDiscussions() {
    $scope.chargementForum = true;
    console.log('Chargement des discussions pour le jeu de données:', $scope.filtres.jeuDonnees);
    
    // Ajouter une discussion test au cas où
    var discussionTest = {
      id: 9999,
      titre: "Aucune discussion trouvée",
      contenu: "Aucune discussion trouvée.",
      auteur: "Système",
      jeuDonneesCode: $scope.filtres.jeuDonnees || "BUDGET_GENERAL",
      date: new Date(),
      nombreReponses: 0
    };
    
    // Fonction à exécuter à la fin du chargement
    function finaliserChargement() {
      $scope.chargementForum = false;
      
      // Si aucune discussion n'a été chargée, ajouter une discussion de test
      if ($scope.discussions.length === 0) {
        console.log('Aucune discussion trouvée, ajout d\'une discussion de test');
        $scope.discussions = [discussionTest];
      }
      
      // Filtrer et trier les discussions
      filtrerDiscussions();
    }
    
    // Si aucun jeu de données sélectionné, charger toutes les discussions
    if (!$scope.filtres.jeuDonnees) {
      ForumApiService.getAllDiscussions()
        .then(function(response) {
          console.log('Discussions chargées:', response ? response.length : 0);
          $scope.discussions = response || [];
        })
        .catch(function(error) {
          console.error('Erreur lors du chargement des discussions:', error);
          $scope.discussions = [];
        })
        .finally(function() {
          finaliserChargement();
        });
    } else {
      // Sinon, charger les discussions pour le jeu de données spécifique
      ForumApiService.getDiscussionsByJeuDonnees($scope.filtres.jeuDonnees)
        .then(function(response) {
          console.log('Discussions filtrées chargées:', response ? response.length : 0);
          $scope.discussions = response || [];
        })
        .catch(function(error) {
          console.error('Erreur lors du chargement des discussions filtrées:', error);
          $scope.discussions = [];
        })
        .finally(function() {
          finaliserChargement();
        });
    }
  }
  
  // Filtrer et trier les discussions
  function filtrerDiscussions() {
    if (!$scope.discussions || !Array.isArray($scope.discussions)) {
      $scope.discussionsFiltrees = [];
      return;
    }
    
    // Copie des discussions pour filtrage et tri
    var discussions = $scope.discussions.slice();
    
    // Appliquer le tri
    switch ($scope.triDiscussions) {
      case 'date_desc':
        discussions.sort(function(a, b) {
          return new Date(b.createdAt || b.date) - new Date(a.createdAt || a.date);
        });
        break;
      case 'date_asc':
        discussions.sort(function(a, b) {
          return new Date(a.createdAt || a.date) - new Date(b.createdAt || b.date);
        });
        break;
      case 'reponses_desc':
        discussions.sort(function(a, b) {
          return (b.nombreReponses || 0) - (a.nombreReponses || 0);
        });
        break;
      case 'reponses_asc':
        discussions.sort(function(a, b) {
          return (a.nombreReponses || 0) - (b.nombreReponses || 0);
        });
        break;
    }
    
    // Pagination
    $scope.forumPagination.nombrePages = Math.ceil(discussions.length / $scope.forumPagination.elementsParPage);
    if ($scope.forumPagination.pageCourante > $scope.forumPagination.nombrePages) {
      $scope.forumPagination.pageCourante = 1;
    }
    
    // Calculer l'indice de début et de fin pour la pagination
    var debut = ($scope.forumPagination.pageCourante - 1) * $scope.forumPagination.elementsParPage;
    var fin = debut + $scope.forumPagination.elementsParPage;
    
    // Appliquer la pagination
    $scope.discussionsFiltrees = discussions.slice(debut, fin);
    
    console.log('Discussions filtrées et triées:', $scope.discussionsFiltrees.length);
  }
  
  // Changer la page du forum
  $scope.changerPageForum = function(page) {
    if (page < 1 || page > $scope.forumPagination.nombrePages) {
      return;
    }
    $scope.forumPagination.pageCourante = page;
    filtrerDiscussions();
  };
  
  // Obtenir la liste des pages pour la pagination
  $scope.getPagesForum = function() {
    var pages = [];
    var nombrePages = $scope.forumPagination.nombrePages;
    var pageCourante = $scope.forumPagination.pageCourante;
    
    // Si moins de 5 pages, afficher toutes les pages
    if (nombrePages <= 5) {
      for (var i = 1; i <= nombrePages; i++) {
        pages.push(i);
      }
    } else {
      // Sinon, afficher 5 pages centrées autour de la page courante
      if (pageCourante <= 3) {
        // Début de la pagination
        pages = [1, 2, 3, 4, 5];
      } else if (pageCourante >= nombrePages - 2) {
        // Fin de la pagination
        for (var i = nombrePages - 4; i <= nombrePages; i++) {
          pages.push(i);
        }
      } else {
        // Milieu de la pagination
        for (var i = pageCourante - 2; i <= pageCourante + 2; i++) {
          pages.push(i);
        }
      }
    }
    
    return pages;
  };
  
  // Changer le tri des discussions
  $scope.changerTriDiscussions = function(tri) {
    $scope.triDiscussions = tri;
    filtrerDiscussions();
  };
  
  // Fonction pour partager une discussion sur les réseaux sociaux
  $scope.partagerDiscussion = function(discussion, reseau) {
    var titre = encodeURIComponent("Discussion budgétaire: " + discussion.titre);
    var url = encodeURIComponent(window.location.origin + window.location.pathname + "?discussion=" + discussion.id);
    var texte = encodeURIComponent("Je vous partage cette discussion concernant le budget du Tchad: " + discussion.titre);
    
    var lienPartage;
    
    switch (reseau) {
      case 'facebook':
        // URL non encodée pour le lien direct à partager
        var rawUrl = window.location.origin + window.location.pathname + "?discussion=" + discussion.id;
        // Facebook préfère le format simple avec uniquement le paramètre u=
        lienPartage = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(rawUrl);
        break;
      case 'twitter':
        lienPartage = 'https://twitter.com/intent/tweet?text=' + texte + '&url=' + url;
        break;
      case 'whatsapp':
        lienPartage = 'https://wa.me/?text=' + texte + ' ' + url;
        break;
      case 'linkedin':
        lienPartage = 'https://www.linkedin.com/shareArticle?mini=true&url=' + url + '&title=' + titre + '&summary=' + texte;
        break;
      case 'email':
        lienPartage = 'mailto:?subject=' + titre + '&body=' + texte + '\n\n' + url;
        break;
      default:
        console.error('Réseau social non pris en charge:', reseau);
        return;
    }
    
    // Ouvrir dans une nouvelle fenêtre/onglet
    window.open(lienPartage, '_blank', 'width=600,height=400');
    console.log('Partage de la discussion', discussion.id, 'sur', reseau, 'URL:', lienPartage);
  };
  
  // Fonction pour publier un nouveau message (créer une discussion)
  $scope.publierMessage = function() {
    // Vérification des champs obligatoires
    if (!$scope.nouveauMessage.titre || !$scope.nouveauMessage.contenu) {
      return;
    }
    
    // Désactiver le bouton pendant l'envoi
    $scope.publierEnCours = true;
    
    // Préparer les données de la discussion
    var discussion = {
      titre: $scope.nouveauMessage.titre,
      contenu: $scope.nouveauMessage.contenu,
      auteur: $scope.nomUtilisateur,
      jeuDonneesCode: $scope.filtres.jeuDonnees || ''
    };
    
    console.log('Envoi d\'une nouvelle discussion:', discussion);
    
    // Appel API pour créer la discussion
    ForumApiService.createDiscussion(discussion)
      .then(function(discussionCreee) {
        console.log('Discussion créée avec succès:', discussionCreee);
        
        // Formater la date
        if (discussionCreee.createdAt) {
          if (Array.isArray(discussionCreee.createdAt)) {
            discussionCreee.date = new Date(
              discussionCreee.createdAt[0],
              discussionCreee.createdAt[1] - 1,
              discussionCreee.createdAt[2],
              discussionCreee.createdAt[3],
              discussionCreee.createdAt[4],
              discussionCreee.createdAt[5],
              discussionCreee.createdAt[6] ? Math.floor(discussionCreee.createdAt[6] / 1000000) : 0
            );
          } else {
            discussionCreee.date = new Date(discussionCreee.createdAt);
          }
        } else {
          discussionCreee.date = new Date();
        }
        
        // Ajouter la discussion en tête de liste
        discussionCreee.reponses = [];
        discussionCreee.nombreReponses = 0;
        $scope.discussions.unshift(discussionCreee);
        
        // Recharger les discussions filtrées
        filtrerDiscussions();
        
        // Réinitialiser le formulaire
        $scope.nouveauMessage = {
          titre: '',
          contenu: ''
        };
      })
      .catch(function(error) {
        console.error('Erreur lors de la création de la discussion:', error);
        alert('Une erreur est survenue lors de la publication de votre discussion. Veuillez réessayer.');
      })
      .finally(function() {
        $scope.publierEnCours = false;
      });
  };
  
  // La logique d'ajout d'une discussion de test a été déplacée dans finaliserChargement()
  
  // Fonction pour afficher/masquer les réponses d'une discussion
  $scope.toggleReponses = function(discussion) {
    // Si les réponses sont déjà affichées, les masquer
    if (discussion.montrerReponses) {
      discussion.montrerReponses = false;
      return;
    }
    
    // Sinon, charger les réponses depuis l'API
    $scope.chargementReponses = true;
    discussion.montrerReponses = true;
    
    console.log('Chargement des réponses pour la discussion #' + discussion.id);
    
    ForumApiService.getReponsesByDiscussionId(discussion.id)
      .then(function(reponses) {
        console.log('Réponses chargées:', reponses);
        // Assigner les réponses à la discussion
        discussion.reponses = reponses.map(function(reponse) {
          return {
            id: reponse.id,
            contenu: reponse.contenu,
            auteur: reponse.auteur,
            date: reponse.createdAt || new Date(),
            estAdmin: reponse.auteur.toLowerCase().includes('admin') || reponse.auteur.toLowerCase().includes('système')
          };
        });
        // Initialiser le champ pour une nouvelle réponse
        discussion.nouvelleReponse = '';
      })
      .catch(function(error) {
        console.error('Erreur lors du chargement des réponses:', error);
        discussion.reponses = [];
        discussion.nouvelleReponse = '';
      })
      .finally(function() {
        $scope.chargementReponses = false;
      });
  };
  
  // Fonction pour répondre à une discussion
  $scope.repondreDiscussion = function(discussion) {
    if (!discussion.nouvelleReponse || discussion.nouvelleReponse.trim() === '') {
      return;
    }
    
    // Désactiver le bouton pendant l'envoi
    $scope.repondreEnCours = true;
    
    var reponse = {
      contenu: discussion.nouvelleReponse,
      auteur: $scope.nomUtilisateur
      // Ne pas inclure discussionId ici, il est déjà dans l'URL de l'API
    };
    
    console.log('Envoi d\'une réponse à la discussion #' + discussion.id + ':', reponse);
    
    ForumApiService.createReponse(discussion.id, reponse)
      .then(function(reponseCreee) {
        console.log('Réponse créée avec succès:', reponseCreee);
        
        // Ajouter la réponse à la liste des réponses
        discussion.reponses.push({
          id: reponseCreee.id,
          contenu: reponseCreee.contenu,
          auteur: reponseCreee.auteur,
          date: reponseCreee.createdAt || new Date(),
          estAdmin: reponseCreee.auteur.toLowerCase().includes('admin')
        });
        
        // Incrémenter le nombre de réponses
        discussion.nombreReponses = (discussion.nombreReponses || 0) + 1;
        
        // Réinitialiser le champ de saisie
        discussion.nouvelleReponse = '';
      })
      .catch(function(error) {
        console.error('Erreur lors de la création de la réponse:', error);
        alert('Une erreur est survenue lors de l\'envoi de votre réponse. Veuillez réessayer.');
      })
      .finally(function() {
        $scope.repondreEnCours = false;
      });
  };
  
  // Fonction pour filtrer les données du tableau en fonction du texte de recherche
  $scope.filtrerTableau = function() {
    console.log('Filtrage du tableau avec le texte:', $scope.tableauFiltre);
    
    // S'assurer que donneesIndexees existe
    if (!$scope.donneesIndexees || !Array.isArray($scope.donneesIndexees)) {
      $scope.tableauDonneesFiltrees = [];
      return;
    }
    
    // Si le filtre est vide, afficher toutes les données
    if (!$scope.tableauFiltre || $scope.tableauFiltre.trim() === '') {
      $scope.tableauDonneesFiltrees = $scope.donneesIndexees.slice();
    } else {
      // Filtrer les données en fonction du texte de recherche
      var texteRecherche = $scope.tableauFiltre.toLowerCase().trim();
      $scope.tableauDonneesFiltrees = $scope.donneesIndexees.filter(function(item) {
        // Rechercher dans le libellé et le chemin
        return item.libelle.toLowerCase().includes(texteRecherche) || 
              (item.path && item.path.toLowerCase().includes(texteRecherche));
      });
    }
    
    // Mettre à jour la pagination
    $scope.tableauPagination.nombrePages = Math.ceil($scope.tableauDonneesFiltrees.length / $scope.tableauPagination.elementsParPage);
    if ($scope.tableauPagination.pageCourante > $scope.tableauPagination.nombrePages) {
      $scope.tableauPagination.pageCourante = 1;
    }
    
    // Appliquer le tri aux données filtrées
    $scope.trierTableau();
    
    console.log('Données filtrées:', $scope.tableauDonneesFiltrees.length);
  };
  
  // Fonction pour trier les données du tableau
  $scope.trierTableau = function() {
    console.log('Tri du tableau par', $scope.tableauTri.champ, 'en ordre', $scope.tableauTri.ordre);
    
    // S'assurer que tableauDonneesFiltrees existe
    if (!$scope.tableauDonneesFiltrees || !Array.isArray($scope.tableauDonneesFiltrees)) {
      return;
    }
    
    // Trier les données selon le champ et l'ordre sélectionnés
    $scope.tableauDonneesFiltrees.sort(function(a, b) {
      var valA, valB;
      
      // Déterminer les valeurs à comparer selon le champ
      switch($scope.tableauTri.champ) {
        case 'montant':
          valA = parseFloat(a.montant) || 0;
          valB = parseFloat(b.montant) || 0;
          break;
        case 'pourcentage':
          valA = parseFloat(a.pourcentage) || 0;
          valB = parseFloat(b.pourcentage) || 0;
          break;
        case 'libelle':
        default:
          valA = (a.libelle || '').toLowerCase();
          valB = (b.libelle || '').toLowerCase();
          break;
      }
      
      // Appliquer l'ordre de tri
      if ($scope.tableauTri.ordre === 'asc') {
        return valA > valB ? 1 : valA < valB ? -1 : 0;
      } else {
        return valA < valB ? 1 : valA > valB ? -1 : 0;
      }
    });
  };
  
  // Fonction pour changer le tri du tableau
  $scope.changerTriTableau = function(champ) {
    console.log('Changement du tri du tableau vers le champ:', champ);
    
    // Si on clique sur le même champ, inverser l'ordre
    if ($scope.tableauTri.champ === champ) {
      $scope.tableauTri.ordre = $scope.tableauTri.ordre === 'asc' ? 'desc' : 'asc';
    } else {
      // Sinon, changer le champ et mettre l'ordre par défaut
      $scope.tableauTri.champ = champ;
      $scope.tableauTri.ordre = 'asc';
    }
    
    // Appliquer le tri
    $scope.trierTableau();
  };
  
  // Fonction pour changer de page dans le tableau
  $scope.changerPage = function(page) {
    if (page < 1 || page > $scope.tableauPagination.nombrePages) {
      return;
    }
    $scope.tableauPagination.pageCourante = page;
  };
  
  // Fonction pour obtenir les pages à afficher dans la pagination
  $scope.getPages = function() {
    var pages = [];
    var nombrePages = $scope.tableauPagination.nombrePages;
    var pageCourante = $scope.tableauPagination.pageCourante;
    
    // Si moins de 5 pages, afficher toutes les pages
    if (nombrePages <= 5) {
      for (var i = 1; i <= nombrePages; i++) {
        pages.push(i);
      }
    } else {
      // Sinon, afficher 5 pages centrées autour de la page courante
      if (pageCourante <= 3) {
        // Début de la pagination
        pages = [1, 2, 3, 4, 5];
      } else if (pageCourante >= nombrePages - 2) {
        // Fin de la pagination
        for (var i = nombrePages - 4; i <= nombrePages; i++) {
          pages.push(i);
        }
      } else {
        // Milieu de la pagination
        for (var i = pageCourante - 2; i <= pageCourante + 2; i++) {
          pages.push(i);
        }
      }
    }
    
    return pages;
  };
  
  // Fonction pour exporter le tableau en Excel ou PDF
  $scope.exporterTableau = function(format) {
    console.log('Export du tableau au format', format);
    
    if (!$scope.tableauDonneesFiltrees || $scope.tableauDonneesFiltrees.length === 0) {
      alert('Aucune donnée à exporter');
      return;
    }
    
    try {
      // Titre du document
      var titre = 'Données budgétaires';
      if ($scope.filtres && $scope.filtres.annee) {
        titre += ' ' + $scope.filtres.annee;
      }
      if ($scope.filtres && $scope.filtres.typeDonnees) {
        // Trouver le libellé du type de données
        var typeDonnees = $scope.typesDonnees.find(function(t) {
          return t.id === $scope.filtres.typeDonnees;
        });
        if (typeDonnees) {
          titre += ' - ' + typeDonnees.libelle;
        }
      }
      
      // Préparer les données pour l'export
      var donnees = $scope.tableauDonneesFiltrees.map(function(item) {
        return {
          'Libellé': item.libelle,
          'Montant (FCFA)': item.montant,
          'Pourcentage (%)': item.pourcentage
        };
      });
      
      // Date actuelle pour le nom du fichier
      var date = new Date();
      var dateStr = date.getFullYear() + '-' + 
                   ('0' + (date.getMonth() + 1)).slice(-2) + '-' + 
                   ('0' + date.getDate()).slice(-2);
      var nomFichier = 'export_' + dateStr + '_' + ($scope.filtres.annee || '');
      
      if (format === 'excel') {
        exportExcel(donnees, titre, nomFichier);
      } else if (format === 'pdf') {
        exportPDF(donnees, titre, nomFichier);
      }
    } catch (error) {
      console.error('Erreur lors de l\'export en ' + format, error);
      alert('Une erreur est survenue lors de l\'export. Veuillez réessayer.');
    }
  };
  
  // Fonction pour exporter les données au format Excel
  function exportExcel(donnees, titre, nomFichier) {
    console.log('Exportation Excel:', donnees.length, 'lignes');
    
    // Vérifier que la bibliothèque xlsx est disponible
    if (typeof XLSX === 'undefined') {
      console.error('La bibliothèque SheetJS (XLSX) n\'est pas disponible');
      alert('Export Excel non disponible. La bibliothèque nécessaire n\'est pas chargée.');
      return;
    }
    
    try {
      // Création d'un workbook
      var wb = XLSX.utils.book_new();
      wb.Props = {
        Title: titre,
        Author: "Observatoire Tchadien des Finances Publiques",
        CreatedDate: new Date()
      };
      
      // Ajout d'une feuille de calcul
      wb.SheetNames.push('Données');
      
      // Conversion des données en format worksheet
      var ws = XLSX.utils.json_to_sheet(donnees, {header: Object.keys(donnees[0])});
      
      // Ajout de la feuille au workbook
      wb.Sheets['Données'] = ws;
      
      // Export du fichier Excel
      XLSX.writeFile(wb, nomFichier + '.xlsx');
      
      console.log('Export Excel réussi');
    } catch (error) {
      console.error('Erreur lors de l\'export Excel:', error);
      alert('Une erreur est survenue lors de l\'export Excel. Veuillez réessayer.');
    }
  }
  
  // Fonction pour exporter les données au format PDF
  function exportPDF(donnees, titre, nomFichier) {
    console.log('Exportation PDF:', donnees.length, 'lignes');
    
    // Vérifier que les bibliothèques jsPDF et AutoTable sont disponibles
    if (typeof jspdf === 'undefined' || typeof jspdf.jsPDF === 'undefined') {
      console.error('La bibliothèque jsPDF n\'est pas disponible');
      alert('Export PDF non disponible. La bibliothèque jsPDF n\'est pas chargée.');
      return;
    }
    
    try {
      // Récupération de la bibliothèque jsPDF
      var jsPDF = jspdf.jsPDF;
      
      // Création d'un document PDF
      var doc = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'a4'
      });
      
      // Ajout du titre
      doc.setFontSize(16);
      doc.text(titre, 14, 22);
      
      // Ajout de la date
      doc.setFontSize(10);
      doc.text('Généré le ' + new Date().toLocaleDateString(), 14, 30);
      
      // Préparation des données pour AutoTable
      var colonnes = Object.keys(donnees[0]).map(function(key) {
        return { header: key, dataKey: key };
      });
      
      // Vérifier si autoTable est disponible
      if (typeof doc.autoTable !== 'function') {
        console.error('Le plugin AutoTable pour jsPDF n\'est pas disponible');
        alert('Export PDF avancé non disponible. Le plugin AutoTable pour jsPDF n\'est pas chargé.');
        
        // Solution de secours - générer un PDF simple sans tableau
        doc.save(nomFichier + '.pdf');
        return;
      }
      
      // Création d'un tableau avec AutoTable
      doc.autoTable({
        startY: 35,
        columns: colonnes,
        body: donnees,
        theme: 'striped',
        headStyles: { fillColor: [41, 128, 185], textColor: 255 },
        styles: { fontSize: 10, cellPadding: 3 },
        columnStyles: {
          'Montant (FCFA)': { halign: 'right' },
          'Pourcentage (%)': { halign: 'right' }
        },
        didDrawPage: function(data) {
          // Pied de page
          var str = 'Page ' + doc.internal.getNumberOfPages();
          doc.setFontSize(8);
          doc.text(str, doc.internal.pageSize.width - 20, doc.internal.pageSize.height - 10);
        }
      });
      
      // Sauvegarde du PDF
      doc.save(nomFichier + '.pdf');
      
      console.log('Export PDF réussi');
    } catch (error) {
      console.error('Erreur lors de l\'export PDF:', error);
      alert('Une erreur est survenue lors de l\'export PDF. Veuillez réessayer.');
    }
  };
  
  // Fonction pour partager un graphique sur les réseaux sociaux
  $scope.partagerSurReseau = function(reseau) {
    console.log('Partage du graphique sur ' + reseau);
    
    try {
      // Capturer le graphique en tant qu'image
      var canvas = document.getElementById('tofeChart');
      if (!canvas) {
        console.error('Canvas du graphique introuvable');
        return;
      }
      
      // Créer les paramètres de partage
      var titre = 'Données budgétaires ';
      if ($scope.filtres && $scope.filtres.annee) {
        titre += $scope.filtres.annee + ' - ';
      }
      if ($scope.filtres && $scope.filtres.typeDonnees) {
        // Trouver le libellé correspondant au type de données
        var typeLibelle = '';
        if ($scope.typesDonnees && $scope.typesDonnees.length) {
          var typeObj = $scope.typesDonnees.find(function(type) {
            return type.id === $scope.filtres.typeDonnees;
          });
          if (typeObj) {
            typeLibelle = typeObj.libelle;
          }
        }
        titre += typeLibelle || $scope.filtres.typeDonnees;
      }
      
      // Créer l'URL de partage avec les paramètres actuels
      var shareUrl = window.location.origin + window.location.pathname + '?' + 
                     'jeuDonnees=' + encodeURIComponent($scope.filtres.jeuDonnees || '') + '&' +
                     'typeDonnees=' + encodeURIComponent($scope.filtres.typeDonnees || '') + '&' +
                     'annee=' + encodeURIComponent($scope.filtres.annee || '') + '&' +
                     'graphique=' + encodeURIComponent($scope.graphiqueTypeActif || 'bar');
      
      var description = 'Visualisation des données budgétaires de l\'Observatoire Tchadien des Finances Publiques';
      var encodedUrl = encodeURIComponent(shareUrl);
      var encodedTitre = encodeURIComponent(titre);
      var encodedDescription = encodeURIComponent(description);
      
      // Ouvrir la fenêtre de partage en fonction du réseau social
      var shareWindow;
      switch (reseau) {
        case 'facebook':
          shareWindow = window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodedUrl, '_blank', 'width=600,height=400');
          break;
          
        case 'twitter':
          shareWindow = window.open('https://twitter.com/intent/tweet?text=' + encodedTitre + '&url=' + encodedUrl, '_blank', 'width=600,height=400');
          break;
          
        case 'linkedin':
          shareWindow = window.open('https://www.linkedin.com/sharing/share-offsite/?url=' + encodedUrl, '_blank', 'width=600,height=400');
          break;
          
        case 'whatsapp':
          shareWindow = window.open('https://api.whatsapp.com/send?text=' + encodedTitre + ' ' + encodedUrl, '_blank', 'width=600,height=400');
          break;
          
        case 'telegram':
          shareWindow = window.open('https://t.me/share/url?url=' + encodedUrl + '&text=' + encodedTitre, '_blank', 'width=600,height=400');
          break;
          
        case 'email':
          var body = titre + '\n\n' + description + '\n\n' + shareUrl;
          var mailtoLink = 'mailto:?subject=' + encodeURIComponent('Partage de données budgétaires') + '&body=' + encodeURIComponent(body);
          window.location.href = mailtoLink;
          break;
          
        default:
          console.error('Réseau social non pris en charge:', reseau);
          return;
      }
      
      // Focus sur la fenêtre de partage
      if (shareWindow) {
        shareWindow.focus();
      }
      
      console.log('Partage réussi sur ' + reseau);
    } catch (error) {
      console.error('Erreur lors du partage sur ' + reseau + ':', error);
      alert('Une erreur s\'est produite lors du partage. Veuillez réessayer.');
    }
  };
  
  // Appel de l'initialisation
  initialiser();
}
